import { render, staticRenderFns } from "./How.vue?vue&type=template&id=612e9ab7&scoped=true&lang=html&"
import script from "./How.vue?vue&type=script&lang=js&"
export * from "./How.vue?vue&type=script&lang=js&"
import style0 from "./How.vue?vue&type=style&index=0&id=612e9ab7&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e9ab7",
  null
  
)

export default component.exports